var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M.5 0v40h53.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M53.7 40V0H.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    stroke: "#fc0",
    strokeWidth: 0.3,
    d: "M33.4 10h-.7q-.6-.9-1.3-.6h-2.1l1.3.6c.3.9 1.5 1 1.5 1-.2 1.7-1.7-.1-3 .8-1 .5-1 1.2-1.4 2.2l-.8 1.1h1l-.3.4 1.3-.2-.3.3 1.5-.4v.5l1.4-.6.6.4.1-.8.8.2.2-.7c1 1.5 1.4 3 3.5 3.3l-.2-.7 1.6.7.2-.3q1.4.7 2 .7l-.3-1 .4.2-.6-1.4.6.2-.8-1.2.3-.1V14c1 .4 2.5 1 2.7 2.2.2 2-2 2.6-3.5 2.4 1.1 1 3.1.6 4-.4q.6-.5.8-1.4.5.9.6 2c-.2 1.7-2.5 2.2-4 2.4 1.7 1 4.7-.2 4.9-2.6 0-2-1.3-3-1.9-3.9l-.2-1 .6.3-.4-.7-.7-2 .4.1-1.6-1.9h.5S40.3 8 39.8 7.9l.6-.2q-1.7-.6-3.5.6l.2-.6h-.4v-.6l.4-.5-.6-.1.4-1-.6.2.2-1q-.1.2-.7.3l.3-.7c-.2-.2 0-.8 0-.8-1.3.2-1.5.4-2.2 1.5-1.1 2-.7 3-.5 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    stroke: "red",
    strokeWidth: 0.4,
    d: "m40.3 13 2 1c-.2-.8-1.8-1-2-1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m15 33.3-1.3-.8-1.6.8.4-1.4-1.2-1.2 1.4-.1.8-1.6.5 1.3 1.8.3-1.1 1zm3-6.6-.6-.3-.5.3v-.6l-.4-.4.6-.1.2-.6.3.6h.6l-.4.5zm2.6-3.8-1.2-.6-1.2.7.2-1.3-1-1 1.3-.2.6-1.2.6 1.2 1.3.1-.9 1zm-5.5-5.2-1.4-.8-1.4.8.3-1.6-1.2-1 1.6-.3.6-1.4.8 1.4 1.5.2-1 1.1zm-5 5.4-1.5-.8-1.4.8.4-1.6-1.3-1 1.7-.2.6-1.5.7 1.5 1.6.1-1.2 1z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg);
export default __webpack_public_path__ + "static/media/pg.7ca2e91c9edc1b1b34c1dba14160fef2.svg";
export { ForwardRef as ReactComponent };